import { Link } from "react-router-dom";

export function Logo({ compact = false, className = "" }) {
  return (
    <Link to="/" aria-label="Webhaus – zur Startseite" data-testid="header-logo-link" className={`group flex items-center gap-2.5 ${className}`}>
      <img src="/logo-house.png" alt="" width="640" height="562" className="h-9 w-auto mix-blend-multiply transition-transform duration-300 group-hover:-translate-y-0.5" />
      {!compact && <img src="/logo-word.png" alt="Webhaus" width="1136" height="202" className="h-[22px] w-auto mix-blend-multiply" />}
    </Link>
  );
}
